import i18next from 'i18next';
import * as Yup from 'yup';

export const addCreditCardNewAddressValidationSchema = Yup.object().shape({
  CountryIso3Code: Yup.string().required(
    i18next.t('validationSchema.addCreditCardValidation.countryIsRequired'),
  ),
  AddressLine: Yup.string().required(
    i18next.t('validationSchema.addCreditCardValidation.addressIsRequired'),
  ),
  City: Yup.string().required(
    i18next.t('validationSchema.addCreditCardValidation.cityIsRequired'),
  ),
  StateRegion: Yup.string().required(
    i18next.t('validationSchema.addCreditCardValidation.stateRegionIsRequired'),
  ),
  PostalCode: Yup.string().required(
    i18next.t('validationSchema.addCreditCardValidation.PostalCodeIsRequired'),
  ),
});

export const addCreditCardExistingAddressValidationSchema = Yup.object().shape({
  AddressUid: Yup.string().required(
    i18next.t('validationSchema.addCreditCardValidation.addressIsRequired'),
  ),
});
